"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Icon = require("../Icon");

var _Icon2 = _interopRequireDefault(_Icon);

var _styles = require("../../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

const StyledTag = _styledComponents2.default.span.withConfig({
  displayName: "CriteriaTag__StyledTag",
  componentId: "qzar3a-0"
})(["", " background-color:", ";border-radius:4px;color:", ";display:inline-block;padding:", "px ", "px;line-height:14px;font-size:12px;font-weight:500;opacity:0.9;"], _styles.defaultBody, _styles.colors.tag, _styles.colors.svgFill, (0, _styles.calcPadding)(1), (0, _styles.calcPadding)(2));

const StyledButton = _styledComponents2.default.button.withConfig({
  displayName: "CriteriaTag__StyledButton",
  componentId: "qzar3a-1"
})(["background:none;border:none;color:", ";cursor:pointer;font-size:inherit;outline:none;margin:0;padding:", ";padding-left:", "px;"], _styles.colors.grey, (0, _styles.calcPadding)(0), (0, _styles.calcPadding)(2));

const CriteriaTag = (_ref) => {
  let { children, onRemoveClick } = _ref,
      props = _objectWithoutProperties(_ref, ["children", "onRemoveClick"]);

  return _react2.default.createElement(
    StyledTag,
    props,
    _react2.default.createElement(
      "span",
      null,
      children
    ),
    onRemoveClick && _react2.default.createElement(
      StyledButton,
      _extends({ onClick: () => onRemoveClick() }, props),
      _react2.default.createElement(_Icon2.default, { name: "close" })
    )
  );
};

CriteriaTag.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node,
  onRemoveClick: _propTypes2.default.func
};

exports.default = CriteriaTag;